import React, { memo, useMemo } from 'react';

// NOTE: The original build pointed this at /assets/images/app_logo.png,
// a file that was never included in the project — the logo silently
// failed to render everywhere. Replaced with a crisp inline SVG mark
// (a "clearance stamp") so the brand mark always renders, scales
// cleanly at any size, and needs no network/asset request.
const AppLogo = memo(function AppLogo({ size = 64, className = '', onClick }) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="ClearanceConnect logo"
        role="img"
        className="flex-shrink-0"
      >
        <rect x="2" y="2" width="60" height="60" rx="4" stroke="var(--primary)" strokeWidth="3" strokeDasharray="6 4" />
        <rect x="10" y="10" width="44" height="44" fill="var(--foreground)" />
        <path d="M20 32 L28 40 L44 22" stroke="var(--primary)" strokeWidth="4.5" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
      </svg>
    </div>
  );
});

export default AppLogo;
